"use client";

import { useRouter, useSearchParams } from "next/navigation";

interface UseSearchParamsManagerReturn {
  updateParam: (key: string, value: string) => void;
  removeParam: (key: string) => void;
  getParam: (key: string) => string | null;
  getAllParams: () => URLSearchParams;
  updateMultipleParams: (params: Record<string, string>) => void;
}

export function useSearchParamsManager(): UseSearchParamsManagerReturn {
  const router = useRouter();
  const searchParams = useSearchParams();

  const updateParam = (key: string, value: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set(key, value);
    router.push(`?${params.toString()}`);
  };

  const updateMultipleParams = (newParams: Record<string, string>) => {
    const params = new URLSearchParams(searchParams.toString());
    Object.entries(newParams).forEach(([key, value]) => {
      params.set(key, value);
    });
    router.push(`?${params.toString()}`);
  };

  const removeParam = (key: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.delete(key);
    router.push(`?${params.toString()}`);
  };

  const getParam = (key: string) => {
    return searchParams.get(key);
  };

  const getAllParams = () => {
    return new URLSearchParams(searchParams.toString());
  };

  return {
    updateParam,
    removeParam,
    getParam,
    getAllParams,
    updateMultipleParams,
  };
}
